// "Developing Intrusion Detection System (IDS) for CAN network security on Hyundai Vehicles. Implemented with C/C++ and Verilog on ARM MCUs and FPGA, and debugged with logic analyzer and oscilloscope."

export const experience = [
    {
        id: 1,
        company: "CPSec Lab",
        title: "Graduate Research Assistant",
        period: "October 2024 - Present",
        description: "Developing Intrusion Detection System (IDS) for CAN network security on Hyundai Vehicles. Simulated network with multiple ARM microcontrollers programmed with C++ that periodically send CAN messages to eachother. Implementing IDS with C and Verilog on a Xilinx Pynq Z2 SoC and FPGA and debugging with oscilloscope and digital logic analyzer. "
    },
    {
        id: 2,
        company: "PayPal",
        title: "Software Engineer Intern",
        period: "May 2023 - August 2023",
        description: "Worked on the Global Network Services(GNS) team to develop a full stack network topology application to swiftly find the root cause of network faults and sped up recovery by 30%. Used React.js for frontend, Golang for backend, Redis Stack database, and Docker/Kubernetes/Jenkins for deployment."
    },
    {
        id: 3,
        company: "Oceaneering",
        title: "Software Engineer Intern",
        period: "May 2022 - January 2023",
        description: "Wrote embedded software to control disposable subsea surveillance vehicles for the United States Navy. Created a publish-subscribe data sharing architecture using .NET applications with C# to link two DDS (data distribution service) implementations to yield a Linux to Windows cross-platform system. Leveraged Linux system administration to run and regulate vehicle software."
    },
    {
        id: 4,
        company: "Terps Racing",
        title: "Low Voltage Team Member",
        period: "March 2021 - April 2022",
        description: "Oversaw development of Heads-Up Display to report real-time speed, temperature, and battery data from sensors using C++ and Python with CAN (controller area network) protocol. Applied embedded software and integrated circuits to optimize race car electrical system."
    },
    {
        id: 5,
        company: "UMD RCPS Lab",
        title: "Software Engineer Intern",
        period: "June 2019 - September 2019",
        description: "Wrote embedded software for self-driving golf cart through integration of LiDAR (light, distance, and ranging) sensor system. Programmed LiDAR sensor using Python and Linux to record 1,080 distance values across a 270 degree field of view. Utilized TCP/IP protocol to obtain distance from sensor using a Raspberry Pi. Introduced closed loop software to control throttle based on distance from obstacles."
    }
];